import { z } from "zod";

export const KsefEnrichSchema = z
  .object({
    statement_id: z.string().uuid().optional(),
    from: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional(),
    to: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional(),
    overwrite: z.boolean().default(false),
  })
  .refine((d) => d.statement_id !== undefined || (d.from !== undefined && d.to !== undefined), {
    message: "Provide statement_id or both from and to",
  });

export type KsefEnrichRequest = z.infer<typeof KsefEnrichSchema>;

export interface KsefEnrichResult {
  enriched: number;
  certain: number;
  probable: number;
  unconfirmed: number;
  no_match: number;
  skipped: number;
  errors: string[];
}
